// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"fd1c7f3d","409":"1d2eb829"}[chunkId] + ".chunk.js";
};